import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';

import "./main-view-dialog.scss";
import EvBusMain from "../../utils/evbus";
import MainView from "./main-view";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const MainViewDialog = (props) => {

  const [open, setOpen] = React.useState(false);

  const onClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    const handleOpenEvent = () => {
      setOpen(true);
    };
    const handleCloseEvent = () => {
      setOpen(false);
    }

    EvBusMain.on("OPEN-DEPOSIT-TICKET-DIALOG", handleOpenEvent);
    EvBusMain.on("CLOSE-DEPOSIT-TICKET-DIALOG", handleCloseEvent);

    return () => {
      EvBusMain.remove("OPEN-DEPOSIT-TICKET-DIALOG", handleOpenEvent);
      EvBusMain.remove("CLOSE-DEPOSIT-TICKET-DIALOG", handleCloseEvent);
    }
  }, []);

  if (!open) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      className="deposit-ticket-main-view-dialog"
    >
      <MainView onClose={onClose} />
    </Dialog>
  );
}

export default MainViewDialog;